import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function useScrollToAnchor() {
  const location = useLocation()

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      const id = location.hash.substring(1)

      // Wait for lazy-loaded components to render
      const scrollToElement = () => {
        const element = document.getElementById(id)
        if (element) {
          // Add a small delay to ensure all components are rendered
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }, 100)
          return true
        }
        return false
      }

      // Try immediately
      if (!scrollToElement()) {
        // If not found, retry after components load
        const retryIntervals = [200, 500, 1000, 2000]
        retryIntervals.forEach((delay) => {
          setTimeout(() => {
            scrollToElement()
          }, delay)
        })
      }
    }
  }, [location])
}
